export default __webpack_public_path__ + "static/media/404.bc5c5b31.png";